module.exports = __webpack_public_path__ + "media/images/85/narcolepsy_moon_mountains-fe974fc18f936a968e419f9d5821ae45.webp";